import React from "react";
import AllApplicants from "./Applicant/AllApplicants";
import JobBoards from "./Applicant/JobBoards";
import { NewTab, PageTabAdv } from "../../../components";
import Campaigns from "./Applicant/Campaigns";
import InternalSubmissions from "./Applicant/InternalSubmissions";
import InterviewFollowup from "./Applicant/InterviewFollowup";
import Confirmed from "./Applicant/Confirmed";
import { useModuleAccess } from "../../../hooks";

const Applicants = () => {
  const applicantsMenus = [
    {
      title: "All Applicants",
      page: <AllApplicants />,
      type: "main",
      id: "applicants_allapplicants",
    },
    {
      title: "Job Boards",
      page: <JobBoards />,
      type: "main",
      id: "applicants_jobboards",
    },
    // {
    //   title: "Campaigns",
    //   page: <Campaigns />,
    //   type: "main"
    // },
    // {
    //   title: "Internal Submissions",
    //   page: <InternalSubmissions />,
    //   type: "main",
    // },
    // {
    //   title: "Interview Follow-up",
    //   page: <InterviewFollowup />,
    //   type: "main",
    // },
    // {
    //   title: "Confirmed/Starts",
    //   page: <Confirmed />,
    //   type: "main",
    // }
  ];
  const filteredTabs = useModuleAccess({
    allTabs: applicantsMenus,
    parentId: "applicants",
  });
  return (
    <div className="flex flex-1 h-full ">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="applicants"
      />
    </div>
  );
};

export default Applicants;
